import { useEffect, useState, useRef } from "react"
import {server_URL, setSS, getSS } from ".";

function TagMenu({fileID, toClose}){
    const [output,setoutput] = useState(null)

    const [originaltags,setoriginaltags] = useState(null)
    const [tagvalues,settagvalues] = useState(null)

    function equip(tagid){ // remove tag from avail (attach tag to item)
        const newAllTags = { ...tagvalues.alltags }
        const newItemTags = { ...tagvalues.itemtags }

        newItemTags[tagid] = newAllTags[tagid]
        delete newAllTags[tagid]

        settagvalues({
            ...tagvalues,
            alltags: newAllTags,
            itemtags: newItemTags,
            searchedtags : {},
            searchmode : false
        })
    }
    function unequip(tagid){ // add tag to avail (remove tag from item)
        const newAllTags = { ...tagvalues.alltags }
        const newItemTags = { ...tagvalues.itemtags }

        newAllTags[tagid] = newItemTags[tagid]
        delete newItemTags[tagid]

        settagvalues({
            ...tagvalues,
            alltags: newAllTags,
            itemtags: newItemTags,
            searchedtags : {},
            searchmode : false
        })
    }

    async function loadtags(){
        const query = new URLSearchParams(window.location.search)
        if (query.get("cached")==null){
            toClose("cache unavailable")
            return
        }
        let output = null
        try {
            const response = await fetch(server_URL()+"fetchcontenttags/"+query.get("cached")+"/"+(fileID!=="sortbytags"?fileID:"all"))
            output = await response.json()
            if (response.status!=200){
                toClose("status "+response.status+", "+output["message"])
                return
            }
        } catch (error) {
            toClose("error occured")
            console.log(error)
            return
        }
        if (output==null){
            toClose("output null")
            return
        }

        const output_value = fileID==="sortbytags"?(getSS("tags")===""?[]:getSS("tags").split(",")):output["contenttags"]
        setoriginaltags(output_value)

        const content = {
            "itemtags": {},
            "alltags": {},
            "searchedtags": {},
            "searchmode":false
        }

        for (const itemtag of output_value){
            content["itemtags"][itemtag] = output["alltags"][itemtag]
            delete output["alltags"][itemtag]
        }

        content["alltags"] = output["alltags"]

        settagvalues(content)
    }

    function searchfunction(e){
        if(e.key!="Enter"){
            return
        }
        const inputdiv = e.currentTarget
        const value = inputdiv.value

        const newAllTags = { ...tagvalues.alltags }
        const newSearchTags = { ...tagvalues.searchedtags }

        const toUse = {}
        let searchMode = true
        if(value!==""){
            Object.keys(newAllTags).map(key=>{
                if(!newAllTags[key][0].includes(value)){
                    return
                }
                toUse[key] = newAllTags[key]
            })
        }
        else{
            searchMode = false
        }


        settagvalues({
            ...tagvalues,
            alltags: newAllTags,
            itemtags: {...tagvalues.itemtags},
            searchedtags : toUse,
            searchmode : searchMode
        })
    }
    async function savetags(){
        const loadingdiv = document.getElementById("loading.gif")
        loadingdiv.style.visibility = "visible"

        let output = null
        let message = ""
        try {
            if(fileID=="sortbytags"){
                setSS("tags",(""+Object.keys(tagvalues["itemtags"])).replace("[","").replace("]",""))
                message = "tags updated"
                return
            }
            const response = await fetch(server_URL()+"updatecontenttags",{
                method:"POST",
                headers:{
                    "Content-Type":"application/json",
                },
                body:JSON.stringify({
                    "user_cache":new URLSearchParams(window.location.search).get("cached"),
                    "fileid":fileID,
                    "taglist":Object.keys(tagvalues["itemtags"])
                })
            })
            output = await response.json()

            if(response.status!=200){
                message = "status "+response.status+", error occured (check logs)"
                console.log(output["message"])
                return
            }

            message = output["message"]
        } catch (error) {
            message = "error occured"
            console.log(error)
        }
        finally{
            loadingdiv.style.visibility = "hidden"
            toClose(message)
        }


    }



    useEffect(()=>{
        loadtags()
    },[])
    useEffect(()=>{
        if (!tagvalues) return

        const allkeys = tagvalues["alltags"]
        const itemtags = tagvalues["itemtags"]
        const searchedtags = tagvalues["searchedtags"]
        const searchMode = tagvalues["searchmode"]

        const itemtagsdiv = []
        const itemtagsKey = Object.keys(itemtags)
        itemtagsKey.map(key=>{
            itemtagsdiv.push(
                <div key={key} style={{width:"fit-Content",height:"fit-content",borderRadius:"5px",margin:"1px",cursor:"pointer",borderRadius:"3px",background:"lightgray",display:"flex",justifyContent:"center",alignItems:"center",border:"1px solid black"}} onClick={()=>unequip(key)}>
                    <span style={{marginLeft:"2px",marginRight:"2px",marginTop:"1px",marginBottom:"1px"}}>{itemtags[key][0]} ({itemtags[key][1]})</span>
                </div>
            )
        })
        if(itemtagsdiv.length==0){
            itemtagsdiv.push(
                <span key="info1.1" style={{width:"100%",textAlign:"center",fontSize:"11px",fontWeight:"bold",color:"red",margin:"3px"}}>no tags</span>
            )
        }
        let changed = false
        for (const ogtag of originaltags){
            if(ogtag in itemtags){
                continue
            }
            changed = true
            break
        }
        if(originaltags.length!==itemtagsKey.length){
            changed = true
        }
        
        

        const alltagsdiv = []

        let touse = allkeys
        if (searchMode){
            touse = searchedtags
        }
        if(Object.keys(touse).length==0){
            alltagsdiv.push(
                <span key="info1" style={{width:"100%",textAlign:"center",fontSize:"11px",fontWeight:"bold",color:"red",margin:"3px"}}>no tags</span>
            )
        }
        else{
            alltagsdiv.push(
                <div key="searchbar2" style={{width:"100%",height:"fit-Content",display:"flex",alignItems:"center",justifyContent:"center",marginBottom:"5px"}}>
                    <input style={{width:"75%",height:"10px"}} placeholder="search. . ." onKeyDown={(e)=>searchfunction(e)}/>
                </div>
                )
            if(searchMode&&Object.keys(touse).length===0){
                alltagsdiv.push(<span key="info2" style={{width:"100%",textAlign:"center",fontSize:"11px",fontWeight:"bold",color:"red",margin:"3px"}}>not found</span>)
            }
            else{
                Object.keys(touse).map(key=>{
                    alltagsdiv.push(
                        <div key={key} style={{width:"fit-Content",height:"fit-content",borderRadius:"5px",margin:"1px",cursor:"pointer",borderRadius:"3px",background:"lightgray",display:"flex",justifyContent:"center",alignItems:"center",border:"1px solid black"}} onClick={()=>equip(key)}>
                            <span style={{marginLeft:"2px",marginRight:"2px",marginTop:"1px",marginBottom:"1px"}}>{touse[key][0]} ({touse[key][1]})</span>
                        </div>
                    )
                })
            }
        }

        setoutput(
            <>  
                <span style={{fontFamily:"Helvetica, Arial, sans-serif",fontWeight:"bold",fontSize:"14px",width:"100%",textAlign:"center",marginRight:"3px",margin:"3px"}}>Assigned</span>
                <div id="assig-tags" style={{fontFamily:"Helvetica, Arial, sans-serif",width:"100%",height:"100px",fontSize:"10px",borderBottom:"1px solid black",overflowY:"auto"}}>
                    <div style={{width:"100%",height:"fit-Content",display:"flex",flexWrap:"wrap"}}>
                        {itemtagsdiv}
                    </div>
                </div>
                <span style={{fontFamily:"Helvetica, Arial, sans-serif",fontWeight:"bold",fontSize:"14px",width:"100%",textAlign:"center",margin:"3px"}}>Available</span>
                <div id="avail-tags" style={{fontFamily:"Helvetica, Arial, sans-serif",width:"100%",height:"300px",fontSize:"10px",overflowY:"auto"}}>
                    <div style={{width:"100%",height:"fit-Content",display:"flex",flexWrap:"wrap"}}>
                        {alltagsdiv}
                    </div>
                </div>
                <span style={{fontFamily:"Helvetica, Arial, sans-serif",fontWeight:"bold",fontSize:"14px",height:"fit-Content",width:"50px",borderRadius:"5px",border:"1px solid black",visibility:changed?"visible":"hidden",margin:"2px",cursor:"pointer",textAlign:"center",background:"lightgray"}} onClick={savetags}>save</span>
            </>
        )
    },[tagvalues])
    return(
        <div style={{position:"relative",left:"50%",top:"50%",transform:"translate(-50%,-50%)",width:"300px",height:"450px",background:"white",display:"flex",flexDirection:"column",borderRadius:"10px",cursor:"default",alignItems:"center"}}>
            <img id="loading.gif" src={server_URL()+"fetchcontent/gallery-assests/Loading.gif"} style={{position:"absolute",left:"5px",top:"5px",width:"70px",transform:"translate(-28px,-55px)",objectFit:"contain",visibility:"hidden"}}/>
            {output}
        </div>
    )
}

export default TagMenu